import { LicenceHolder } from './LicenceHolder';
import { Locale } from './Locale';
import { Offer } from './Offer';
import { AppConfigInfo } from './AppConfigInfo';
import { UnitAboutApiModel } from './UnitAboutApiModel';
import { WebContentButtonApiModel } from './WebContentButtonApiModel';

export class UnitConfigApiModel {
	Unit: UnitConfigApiModel.Unit;
	Offer: Offer;
	Locale: Locale;
	AppConfig: AppConfigInfo;
	LicenceHolder: LicenceHolder;
	Translations: { [alias: string]: string };
	Theme: UnitConfigApiModel.Theme;
	TermsOfServiceUrl: string;
	PrivacyPolicyUrl: string;
	ReceptionId: number;

	// Not in backend
	About: UnitAboutApiModel;
	WebContentButtons: WebContentButtonApiModel[];

	// isPreNodeSelection() {
	// 	return this.LicenceHolder.HasMultipleLandingPages && this.LicenceHolder.RootUnit === this.Unit.UnitId;
	// }
}

export module UnitConfigApiModel {
	export class Unit {
		UnitId: number;
		Name: string;
	}

	export type Theme = { [alias: string]: string | number | boolean };
}
